// extracted by mini-css-extract-plugin
export default {"root":"StatsGrid_root__1Ti0B","value":"StatsGrid_value__cCjYJ","diff":"StatsGrid_diff__Xcfli","icon":"StatsGrid_icon__-SLJh","title":"StatsGrid_title__s-1Dx"};